import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import taiChi4049Webp from '@/assets/landing-age-selection/tai-chi-40-49.webp'
import taiChi5059Webp from '@/assets/landing-age-selection/tai-chi-50-59.webp'
import taiChi6069Png from '@/assets/landing-age-selection/tai-chi-60-69.png'
import taiChi7080Png from '@/assets/landing-age-selection/tai-chi-70-80.png'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Tai Chi for beginners',
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_yoga.pages.landing.age_range.40_49'),
					img: taiChi4049Webp,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_yoga.pages.landing.age_range.50_59'),
					img: taiChi5059Webp,
				},
				{
					value: 60,
					analyticValue: '60-69',
					label: $t('female_yoga.pages.landing.age_range.60_69'),
					img: taiChi6069Png,
				},
				{
					value: 70,
					analyticValue: '70+',
					label: $t('female_yoga.pages.landing.age_range.70_80'),
					img: taiChi7080Png,
				},
			],
			otherAgesButton: {
				data: { value: 18, analyticValue: '18-39' },
				text: $t('female_yoga.pages.landing.im_young'),
			},
		}),
	},
}

export default schema
